import React from 'react';

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="space-y-2">
    <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
    <div className="text-gray-600 leading-relaxed">{children}</div>
  </div>
);

const CancellationPolicyPage: React.FC = () => (
  <div className="min-h-screen bg-[#FCFCFC] py-12 px-4 md:px-20">
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Cancellation Policy</h1>
      <p className="text-gray-400 text-sm mb-8">Last updated: August 2026</p>
      <div className="bg-white rounded-xl shadow p-8 space-y-6">
        <Section title="1. Order Cancellation by Customer">
          <p>You may cancel your order before it is shipped. Once an order is shipped, cancellation is not possible. To cancel, go to My Orders and click "Cancel Order", or contact us immediately.</p>
        </Section>
        <Section title="2. Cancellation Window">
          <p>Orders can be cancelled within 24 hours of placement if they are still in "Pending" or "Confirmed" status.</p>
        </Section>
        <Section title="3. Cancellation by Sasta Fashions">
          <p>We reserve the right to cancel orders in cases of stock unavailability, pricing errors, or suspicious order activity. You will be notified and fully refunded in such cases.</p>
        </Section>
        <Section title="4. Refund on Cancellation">
          <p>For prepaid orders, the refund will be credited to your original payment method within 5–7 business days. COD orders have no charge to reverse.</p>
        </Section>
        <Section title="5. Contact Us">
          <p>For cancellation requests, email <span className="text-[#DAA520]">sastadealpvt@gmail.com</span> with your order number.</p>
        </Section>
      </div>
    </div>
  </div>
);

export default CancellationPolicyPage;
